import publisherAPIInstance from "./publisherApiInstance";

export const imagenAPIs = {
  initiateImagenAuth: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/imagen.auth.initiate`, payload),
  createImagenCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/imagen.create-credentials`, payload),
  getImagenCredentials: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/imagen.get-credentials`, payload),
  imagenPublish: ({ payload }) => publisherAPIInstance.post(`/api/v1/integration/imagen.publish`, payload),
  disconnectImagenIntegration: ({ payload }) =>
    publisherAPIInstance.post(`/api/v1/integration/imagen.auth.disconnect`, payload),
};
